import { render, staticRenderFns } from "./BuyBoxBundle.vue?vue&type=template&id=17106976&scoped=true"
import script from "./BuyBoxBundle.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxBundle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxBundle.vue?vue&type=style&index=0&id=17106976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17106976",
  null
  
)

export default component.exports